import React, { useState } from "react";
import { Button } from "../ui/Button";
import { isCapabilityEnabled } from "../../config/capabilities";
import { useToast } from "../../hooks/use-toast";
import { FOUR_D_IMPORT_TYPE } from "./patientActionConfig";
import { uploadPatientNoteTo4d } from "./patientApi";

const UploadTo4dAction = ({ patient }) => {
  const { toast } = useToast();
  const [isUploading, setIsUploading] = useState(false);

  if (
    !isCapabilityEnabled("uploadTo4d") ||
    patient?.import_type !== FOUR_D_IMPORT_TYPE
  ) {
    return null;
  }

  const appointmentId = String(patient.appointment_id || "").trim();
  const hasNote =
    typeof patient.note === "string" && patient.note.trim().length > 0;
  const canUpload = Boolean(patient.patient_id && appointmentId && hasNote);

  const handleUpload = async () => {
    if (!canUpload || isUploading) return;

    const confirmed = window.confirm(
      `Upload this note to 4D for appointment ${appointmentId}?`
    );
    if (!confirmed) return;

    setIsUploading(true);
    const result = await uploadPatientNoteTo4d(patient.patient_id);
    setIsUploading(false);

    if (result.success) {
      toast({ title: "Uploaded to 4D" });
      return;
    }

    toast({
      variant: "destructive",
      title: "Could not upload to 4D",
      description: result.error || "Failed to upload note to 4D.",
    });
  };

  return (
    <div className="flex flex-col items-start gap-2">
      <Button
        type="button"
        onClick={handleUpload}
        disabled={!canUpload || isUploading}
        className="bg-ktx-purple hover:bg-purple-700 text-white"
      >
        {isUploading ? "Uploading…" : "Upload to 4D"}
      </Button>
      {!canUpload && (
        <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
          An appointment ID and a note are required before this can be uploaded to 4D.
        </p>
      )}
    </div>
  );
};

export default UploadTo4dAction;
